import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Card, CardBody, CardFooter, CardHeader } from "../../card/card";
function NormalSelect({
  full = false,
  required = false,
  onchange,
  list,
  value,
  name,
  label,
  textKey = "name",
  renderFn = null,
  valueKey = null,
  defaultValueText = "- Select -",
  addMoreComponent = null,
  onSubmit,
  emptyField = [],
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    if (onSubmit) {
      await onSubmit();
      setOpen(false);
    }
  };
  return (
    <div className="form-group mb-3">
      <label className="form-label" htmlFor="exampleFormControlInput1">
        {label} {required ? <span className="text-danger">*</span> : ""}
      </label>
      <div style={{ display: "flex" }}>
        <select
          className={`form-select ${
            emptyField.includes(name) ? "is-invalid" : ""
          }`}
          style={{ width: !!addMoreComponent ? "90%" : "100%" }}
          onChange={onchange}
          value={value}
          name={name}
        >
          <option value="">{defaultValueText}</option>
          {list.map((f, i) => (
            <option key={i} value={valueKey ? f[valueKey] : f[name]}>
              {renderFn ? renderFn(f[textKey]) : f[textKey]}
            </option>
          ))}
        </select>
        {!!addMoreComponent && (
          <>
            <button
              onClick={handleOpen}
              title={"Add More " + label}
              className="btn btn-sm btn-outline-default"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                borderRadius: "4px",
                width: "10%",
                fontSize: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              +
            </button>

            <Modal show={open} onHide={handleClose} centered>
              <Modal.Body className="p-0">
                <Card>
                  <CardHeader className="p-3">
                    Add More {label}
                    <button
                      className="btn"
                      style={{
                        position: "absolute",
                        fontSize: 8,
                        textTransform: "uppercase",
                        right: 0,
                        top: "0",
                        bottom: "0",
                        marginTop: "auto",
                        marginBottom: "auto",
                        textDecoration: "underline",
                        minWidth: "30px",
                      }}
                      onClick={handleClose}
                    >
                      CLOSE
                    </button>
                  </CardHeader>
                  <CardBody>{addMoreComponent}</CardBody>
                  <CardFooter>
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 0",
                      }}
                    >
                      <button
                        className="btn btn-outline-theme me-2"
                        onClick={handleSubmit}
                      >
                        {"Submit"}
                      </button>
                      <button
                        className="btn btn-outline-danger"
                        onClick={handleClose}
                      >
                        {"Cancel"}
                      </button>
                    </div>
                  </CardFooter>
                </Card>
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    </div>
  );
}

export default NormalSelect;
